/**
 * Copyright (c) 2021 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */
import React from 'react';
import { SigningRoomNavigationItemIds } from '../SigningRoomNavigation/signingRoomItems';
import { useRootSelector } from '../../../hooks/useRootSelector';
import { DeviceSetting } from '../../../components/common/DeviceSetting/DeviceSetting';
import { Signing } from '../../../components/common/Signing/Signing';
import { useVideoContext } from '../../../contexts/videoProvider/videoContext';
import { ParticipantsTab } from '@components/videoProvider/ParticipantsTab/ParticipantsTab';

export namespace SigningRoomPageContent {
  export interface Props {
    setSelectedDocumentAndFetchPdf(documentId: string): Promise<void>;
  }
}

export const SigningRoomPageContent: React.FC<SigningRoomPageContent.Props> = ({ setSelectedDocumentAndFetchPdf }) => {
  const { isMobileView, selectedNavigationItemId } = useRootSelector(state => ({
    isMobileView: state.layout.isMobileView,
    selectedNavigationItemId: state.signingRoom.selectedNavigationItemId,
  }));
  const { videoProvider } = useVideoContext();

  if (!isMobileView) {
    return <Signing setSelectedDocumentAndFetchPdf={setSelectedDocumentAndFetchPdf} />;
  } else {
    switch (selectedNavigationItemId) {
      case SigningRoomNavigationItemIds.participants:
        if (videoProvider.shouldReplaceParticipantTabWithStrip()) {
          // This is for Zoom where we replace the Participants tab with the Zoom Participant Strip
          // So, we don't render anything to make space for the Zoom Participant Strip
          return null;
        }
        return <ParticipantsTab />;
      case SigningRoomNavigationItemIds.documents:
        return <Signing setSelectedDocumentAndFetchPdf={setSelectedDocumentAndFetchPdf} />;
      case SigningRoomNavigationItemIds.settings:
        return <DeviceSetting />;
      default:
        return null;
    }
  }
};
